import { render } from "./RecordIndexView.vue?vue&type=template&id=2dfb8cfb&scoped=true"
import script from "./RecordIndexView.vue?vue&type=script&lang=js"
export * from "./RecordIndexView.vue?vue&type=script&lang=js"

import "./RecordIndexView.vue?vue&type=style&index=0&id=2dfb8cfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfb8cfb"]])

export default __exports__